module.exports = __webpack_public_path__ + "static/img/9.2af96a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/9.jpg
// module id = pfBO
// module chunks = 0